// extracted by mini-css-extract-plugin
export default {"div":"Loader_div__r0Oxi","spin":"Loader_spin__VNdui"};